import { createApp } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import App from "./App.vue"
import { store } from "./store"
import routes from "./config/routes"

const app = createApp(App)
const router = createRouter({
  history: createWebHistory(),
  routes,
})

app.use(store)
app.use(router)
app.mount("#app")